import GcIcon from '@garmin/components-global/src/components/GcIcon/index.vue';
import ImgBanner from '../ImgBanner/index.vue';
import { boolStringToBool } from '../../helpers/typeConverter';

export default {
  name: 'PcVideoBanner',
  data() {
    return {
      className: 'app__video-banner',
      videoIsPlaying: false,
    };
  },
  components: {
    ImgBanner,
    GcIcon,
  },
  props: {
    bgImage: {
      type: String,
      default: '',
    },
    mobileBgImage: {
      type: String,
      default: '',
    },
    videoLink: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
    videoTitle: {
      type: String,
      default: '',
    },
    notYoutube: {
      type: [String, Boolean],
      default: false,
    },
    theme: {
      type: String,
      default: 'dark',
    },
  },
  computed: {
    videoPlayingClassName() {
      return this.videoIsPlaying ? `${this.className}--playing` : '';
    },
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
    videoClassName() {
      return `${this.className}__video`;
    },
    videoElClassName() {
      return `${this.videoClassName}__el`;
    },
    videoPlayBtClassName() {
      return `${this.videoClassName}__play-bt`;
    },
    videoPlayBtIconClassName() {
      return `${this.videoPlayBtClassName}__icon`;
    },
    videoCloseBtClassName() {
      return `${this.videoClassName}__close-bt`;
    },
    videoPlayBtTheme() {
      return this.theme === 'dark' ? 'light' : 'dark';
    },
    videoCloseBtConClassName() {
      return `${this.videoCloseBtClassName}__con`;
    },
    youtubeVideoLink() {
      const url = new URL(this.videoLink);
      const { searchParams } = url;

      if (!searchParams.has('autoplay')) searchParams.append('autoplay', '1');

      return url.toString();
    },
    notYoutubeClassName() {
      return this.isNonYoutubeLink ? `${this.videoClassName}--not-youtube` : '';
    },
    isNonYoutubeLink() {
      return boolStringToBool(this.notYoutube);
    },
  },
  methods: {
    playVideo() {
      this.videoIsPlaying = true;
    },
    closeVideo() {
      this.videoIsPlaying = false;
    },
  },
};
